var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"to":_vm.to,"href":_vm.href,"size":_vm.size,"variant":_vm.variant,"loading":_vm.loading,"disabled":_vm.disabled}},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }